import axios from "axios";

export default {
    name: "piutangKaryawan",
    state: {
        data: Array,
        editdata: Array,
    },
    getters: {
        getManifestPiutangKaryawan: state => {
            return state.data
        },
        getRevisiPiutangKaryawan: state => {
            return state.editdata
        },
    },
    mutations: {
        setmanifest: (state, payload) => {
            state.data = payload
        },
        setrevisi: (state, payload) => {
            state.editdata = payload
        },
    },
    actions: {
        getManifestPiutangKaryawan(store, { auth, id_manifest }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Piutang_karyawan",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        id_manifest: id_manifest
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setmanifest", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getRevisiPiutangKaryawan(store, { auth, id_manifest }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "Piutang_karyawan/revisi",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        id_manifest: id_manifest
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setrevisi", response.data);
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitPiutangKaryawan(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Piutang_karyawan",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitRevisiPiutangKaryawan(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Piutang_karyawan/revisi",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitpayPiutangKaryawan(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "Piutang_karyawan/payment",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
